module.exports = __webpack_public_path__ + "static/media/edit_black.a46f33cb.svg";